import React from 'react'
import ConnectionForm from './ConnectionForm'
import * as schema from '../../validation'
import I18n, { useI18nFunction } from '../I18n'
import {
  organizationName,
  organizationNumber,
  country,
  fromDate,
  toDate,
  comment,
  isCompanyRegistered,
  shareType,
  isSupplierInfo,
  isClientInfo,
  ownershipStatus,
  isCompanyListed,
  stockCount,
  isCaseRelevant,
} from './fields'
import {
  USER_INDIRECT_OWNERSHIP,
  USER_INDIRECT_ROLE,
  RELATION_INDIRECT_OWNERSHIP,
  RELATION_INDIRECT_ROLE
} from '../../ownershipTypes'
import IndirectOwnershipForm from './IndirectOwnershipForm'

const OwnershipForm = (props) => {
  const I18nFunction = useI18nFunction();

  const isIndirect = [
    USER_INDIRECT_OWNERSHIP,
    USER_INDIRECT_ROLE,
    RELATION_INDIRECT_OWNERSHIP,
    RELATION_INDIRECT_ROLE
  ].includes(props.connection?.ownershipType)


  return (
    isIndirect ?
      <IndirectOwnershipForm
        {...props}
      />
      :
      <ConnectionForm
        {...props}
        heading={<I18n id="connection_form.headings.ownership" />}
        schema={schema.ownership(I18nFunction)}
        fields={fields}
      />
  )
}

export const fields = [
  isCompanyRegistered(),
  country(),
  organizationName(),
  organizationNumber(),
  isSupplierInfo(),
  isClientInfo(),
  isCompanyListed(),
  shareType(),
  stockCount(),
  ownershipStatus(),
  fromDate(
    <I18n id="connection_form.labels.ownership_from" />,
    <I18n id="connection_form.help_texts.from_date_ownership" />,
  ),
  toDate(
    <I18n id="connection_form.labels.ownership_to" />,
    <I18n id="connection_form.help_texts.to_date_ownership" />,
  ),
  comment(),
  isCaseRelevant(),
]

export default OwnershipForm
